import { Component, createRef } from "react";
import { NSSectionTitle, NSRow, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSQBillWatchTrialGauges } from "namirasoft-quota-react";

import { BillWatchLayout } from '../BillWatchLayout';
import { BillWatchProps } from "../BillWatchProps";

interface UsagePageProps extends NSARouterMakerResult, BillWatchProps { }

export default class UsagePage extends Component<UsagePageProps>
{
    BillWatchLayout_Ref = createRef<BillWatchLayout>();

    override render()
    {
        return (
            <BillWatchLayout
                ref={this.BillWatchLayout_Ref}
                {...this.props}
                action={{
                    title: "Usage Report",
                    description: "You can visually see how much of your current plan has been used, helping you track usage and limits.",
                    menus: {}
                }}
            >
                <NSSectionTitle title="Free Trial Usage Detail">
                    <NSSpace size={NSSpaceSizeType.MINI} />
                    <NSRow>
                        <NSQBillWatchTrialGauges {...this.props} />
                    </NSRow>
                </NSSectionTitle>
            </BillWatchLayout>
        );
    }
}